// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';

export const Profile = t.struct({
    hideHeader: t.Boolean,
    showEquipmentTile: t.Boolean
}, {
    defaultProps: {
        hideHeader: false,
        showEquipmentTile: true
    },
    name: 'ProfileFeature',
    strict: true
});
